// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchBar_container__98ylW","input":"SearchBar_input__t1UKZ"};